export default __webpack_public_path__ + "695727e72a53f802e95afbf90cc181d9.svg";